import { Text, View } from '@react-pdf/renderer'
import { useTranslation } from 'react-i18next'

import { commonPdfTableStyles } from '@features/exports/utils/commonTableStyles'
import { ReportsType } from '@features/reports/enums/reportsType'
import { getVisibleColumns } from '@features/reports/views/NL/profitAndLossReport/constants/columnConfiguration'

import { useReportsPdfDocument } from '../../../../../../contexts/reportsPdfDocumentContext'
import { columnPdfStyles } from '../../../../../../utils/columnPdfStyles'
import { profitAndLossTableHeaderStyles } from '../../utils/profitAndLossTableHeaderStyles'

export const ReportsPdfTableProfitAndLossHeader = () => {
  const { t } = useTranslation()

  const { periods, reportType, appliedFilters } = useReportsPdfDocument()

  if (reportType !== ReportsType.ProfitAndLoss) {
    return null
  }

  const visibleColumns = getVisibleColumns(appliedFilters.showChange, appliedFilters.showGroupPercentage)
  const showComparisonHeader = visibleColumns.length > 1

  const { columnLabelContainer, container, periodLabelContainer, visibleColumnsContainer } =
    profitAndLossTableHeaderStyles

  return showComparisonHeader ? (
    <View style={[columnPdfStyles.columnFluid, container]}>
      {periods?.map((period) => (
        <View key={period.key} style={columnPdfStyles.columnFluid}>
          <View style={periodLabelContainer}>
            <Text style={commonPdfTableStyles.headerLabelText}>{period.label}</Text>
          </View>

          <View style={visibleColumnsContainer}>
            {visibleColumns.map((column) => (
              <View key={`${period.key}-${column.key}`} style={columnLabelContainer}>
                <Text style={commonPdfTableStyles.headerLabelText}>{t(column.label)}</Text>
              </View>
            ))}
          </View>
        </View>
      ))}
    </View>
  ) : (
    <>
      {periods?.map((period) => (
        <View style={columnPdfStyles.columnFluid}>
          <Text key={period.key} style={commonPdfTableStyles.headerLabelText}>
            {period.label}
          </Text>
        </View>
      ))}
    </>
  )
}
